var path = '/account/main/holdingsWrapper/holdingsWrapper.tpl.html';
var html = "<div class=ifds-kendo-loading> <div id=grdAcctHoldings data-ng-if=holdingsWrapperCtrl.isLoaded ifast-grid ifast-object-id=AcctHoldings ifast-options=holdingsWrapperCtrl.accountHoldingOptions ifast-toolbar-template={{holdingsWrapperCtrl.filterTemplate}} data-ifast-local-data=holdingsWrapperCtrl.gridData.getData() class=ifds-acctHoldings></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/account/main/holdingsWrapper/holdingsWrapper.tpl.html
// module id = 591
// module chunks = 0 2